import React from 'react';
import { arrayOf, shape, string, node } from 'prop-types';
import { Review } from '../Review/Review.component';
import { Overview } from '../Overview/Overview';
import { CustomerImageCarousel } from '../CustomerImageCarousel/CustomerImageCarousel.component';
import { ReviewPager } from '../Paging/ReviewPager.component';
import { Search, Sort } from '../Filter/components';
import { Filter } from '../Filter/Filter.component';
import { Button } from '@thd-olt-component-react/button';
import { Col, Row } from '@thd-olt-component-react/grid';
import { WriteAReview } from '../WriteAReview/WriteAReview.component';
import './MobileOverlay.scss';

export const MobileOverlay = ({
    apiKey,
    brandName,
    imageUrl,
    itemId,
    reviewModels,
    reviewStatistics,
    filterCheckboxes,
    onDeselectFilter,
    onFilterChange,
    onPageChange,
    onSearch,
    onSortChange,
    productLabel,
    searchTerm,
    sortBy,
    selected,
    selectedSentiment
  }) => {

  return (
    <>
      <Row className="rr-mobile-overlay">
        <Col fallback={4}>
          <div className="rr-mobile-overlay__product-image">
            <img src={(imageUrl || '').replace('65', '1000')} alt={productLabel} width={100} loading="lazy" />
          </div>
        </Col>
        <Col fallback={8}>
          <div className="rr-mobile-overlay__product-brand">
            {brandName}
          </div>
          <div className="rr-mobile-overlay__product-label">
            {productLabel}
          </div>
        </Col>
      </Row>
      <Overview
        itemId={itemId}
        reviewStatistics={reviewStatistics}
        filters={[]}
        filterCheckboxes={filterCheckboxes}
        clickableFilters
        onFilterChange={onFilterChange}
      />
      <CustomerImageCarousel itemId={itemId} />
      {selected.length > 0
      && (
        <Col xs="12">
          <h3>{selected.length === 1 ? 'Your Selection:' : 'Your Selections:'}</h3>
          {selected
            .map((checkbox, checkboxIndex) => (
              <Button
                key={checkboxIndex}
                id={checkbox.id}
                onClick={() => onDeselectFilter(checkbox)}
                filter
              >
                {selectedSentiment ? selectedSentiment.Feature : `Ratings ${checkbox.value}`}
              </Button>
            ))}
        </Col>
      )}
      <Row className="ratings-and-reviews__search-and-sort">
        <Col xs={12} sm={12} md={4} lg={4} className="ratings-and-reviews__search-and-filter">
          <Search onSearch={onSearch} searchTerm={searchTerm} noResults={reviewModels.length === 0} />
        </Col>
        <Col xs={12} sm={12} md={5} lg={5} className="ratings-and-reviews__search-and-filter">
          <Filter onChange={onFilterChange} ratingFilters={filterCheckboxes} reviewStatistics={reviewStatistics} selectedSentiment={selectedSentiment} />
        </Col>
        <Col xs={12} sm={12} md={3} lg={3}>
          <Sort onChange={onSortChange} sortBy={sortBy} />
        </Col>
      </Row>
      {reviewModels.map((review, reviewIndex) => {
        return (
          <Review
            review={review}
            id={reviewIndex}
            key={`review-${reviewIndex}`}
            apiKey={apiKey}
            searchTerm={searchTerm}
          />
        );
      })}
      <ReviewPager
        itemId={itemId}
        reviewsPageContext={reviewStatistics.pageContext}
        onPageChanged={onPageChange}
      />
      <Row>
        <Col xs="12" fallback="12">
          {reviewStatistics
          && (
            <WriteAReview
              apiKey={apiKey}
              itemId={itemId}
              className="ratings-and-reviews-mobile__write-a-review"
              reviewStatistics={reviewStatistics}
            />
          )}
        </Col>
      </Row>
    </>
  );
};

MobileOverlay.displayName = 'RatingsAndReviewsMobileOverlay';

MobileOverlay.propTypes = {
  apiKey: string,
  children: node,
  itemId: string,
  mobileReviewsOnFirstPage: arrayOf(shape({})),
  reviewModels: arrayOf(shape({})),
  reviewStatistics: shape({}),
  selected: arrayOf(shape({})),
  target: string
};
